
import request from "../utils/request"

export function getFilter(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/filter",
        method: "get",
        params: _params
    });
}

export function getCompanyList() {
    return request({
        url: "/ui-api/v1/company-list",
        method: "get"
    });
}

export function getLatestDate() {
    return request({
        url: "/ui-api/v1/latest-date",
        method: "get"
    });
}

export function formatDecimal(val,pos) {
    //Math.round(748.5867*100)/100  结果：748.59  保留两位
    //Math.round(748.5867*1000)/1000  结果：748.587  保留三位

    if (isNaN(val) || val == undefined || val == null) 
    { 
        return null; 
    }

    var pow = Math.pow(10, pos);
    var f= Math.round(val * pow) / pow;

    var s = f.toString();
    var rs = s.indexOf('.');
    if(rs < 0){
        rs = s.length;
        s += '.'; 
    }
    while(s.length <= rs + pos){
        s += '0';
    }
    return s;
}

export function formatCeil(val) {
    if (isNaN(val) || val == undefined || val == null) {
        return null;
    }
    return Math.ceil(val);
}

export function dateWithForwardSlash(val) {
    //斜杠分正斜杠（forward slash'/'）和反斜杠（back slash'\'）
    return val.replace("00:00:00.0", "").replace(/-/g, "/");
}

export function getWorkDate(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/funds/work-date",
        method: "get",
        params: _params
    });
}

export function getFundCache(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-cache",
        method: "get",
        params: _params
    });
}

export function getFundCacheForMyList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-cache-for-my-list",
        method: "get",
        params: _params
    });
}

export function getFundCacheRiskDetailForMyList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-cache-for-risk-detail-my-list",
        method: "get",
        params: _params
    });
}


export function download(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/download",
        method: "get",
        params: _params
    });
}

export function downloadFtpFile(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/download-ftp-file",
        method: "get",
        params: _params
    });
}